// Module
var code = " <div md-colors=\"{'background-color': $ctrl.isSelected() ? 'primary' : 'background-100'}\" md-ink-ripple> <div class=\"gb-radio-button-content\" layout=\"column\" layout-align=\"center center\"> <md-icon ng-bind=\"$ctrl.icon\" ng-if=\"$ctrl.icon\" class=\"gb-radio-button-icon\"></md-icon> <ng-transclude></ng-transclude> </div> </div> ";
// Exports
export default code;